type FileExtIconAssociation = {
  fileExt: string;
  faIcon: string;
};

const fileExtensions: FileExtIconAssociation[] = [
  { fileExt: '.doc', faIcon: 'fa-file-word' },
  { fileExt: '.docx', faIcon: 'fa-file-word' },
  { fileExt: '.pdf', faIcon: 'fa-file-pdf' },
];

export default function initDocumentLinks() {
  const docLinksSelector = fileExtensions
    .map((current) => `.page-content a[href$="${current.fileExt}"]`)
    .join(',');

  const docLinks = document.querySelectorAll(
    docLinksSelector
  ) as NodeListOf<HTMLAnchorElement>;

  docLinks.forEach((link) => {
    const faIcon =
      fileExtensions.find((current) => link.href.endsWith(current.fileExt))
        ?.faIcon || 'fa-file';

    link.insertAdjacentHTML(
      'afterbegin',
      `<i class="fas ${faIcon} text-primary mr-2"></i>`
    );
  });
}
